import { useQuery } from '@apollo/client'
import { groupBy } from 'lodash'

import {
  CommandGroup,
  CommandModule,
  DEFAULT_REGISTER_ACTIONS,
  DynamicActionsProps,
} from './config'

import { ProjectDisplay } from '@/components/shared-components/ProjectDisplay'
import { REGISTER_ITEMS_FOR_SEARCH } from '@/modules/registers/graphQL'
import { routes } from '@/utils/index'

import {
  RegisterItemsForSearchUiQuery,
  RegisterItemsForSearchUiQueryVariables,
} from 'types/api.graphql'

export const DynamicRegisterItemActions: React.FC<DynamicActionsProps> = ({
  activePage,
  debouncedSearchText,
  replaceParentSubItems,
}) => {
  useQuery<
    RegisterItemsForSearchUiQuery,
    RegisterItemsForSearchUiQueryVariables
  >(REGISTER_ITEMS_FOR_SEARCH, {
    variables: {
      filter: {
        searchString: debouncedSearchText,
      },
      pagination: { limit: 10, offset: 0 },
    },
    skip:
      activePage !== CommandModule.Registers || !debouncedSearchText?.length,
    onCompleted: (data) => {
      const groupedItems = groupBy(
        data?.registerItems,
        (r) => r.register.identifierPrefix
      )

      const groups = Object.keys(groupedItems).map((key) => {
        return {
          id: key,
          groupTitle: key + ' - ' + groupedItems[key][0].register.name,
          groupActions: [
            {
              id: 'goToRegister' + key,
              name: key,
              href: routes.registers.viewRegister(key),
            },
            ...groupedItems[key].map((item) => ({
              id: item.id,
              name: item.name,
              description: key + '-' + item.identifier,
              extra: <ProjectDisplay projects={item.projects} iconSize={18} />,
              href: routes.registers.viewRegisterItem(key, item.identifier),
            })),
          ],
        } as CommandGroup
      })

      replaceParentSubItems(CommandModule.Registers, [
        ...DEFAULT_REGISTER_ACTIONS,
        ...groups,
      ])
    },
  })

  return null
}
